import axios from 'axios'
import {Toast} from 'vant';
import {
    clearAuthToken,
    clearWxLoginCode,
    getAuthToken,
    getDefaultPatientInfo,
    getHealthCare,
    getToken,
    getWxInfo
} from "@/utils/storage";

// 创建 axios 实例
const requests = axios.create({
    baseURL: process.env.VUE_APP_BASE_PATH,
    timeout: 30000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    }
})

let isRelogin = false

function isLoginRequest(config) {
    const url = (config && config.url) || ''
    return url.indexOf('/wx/mp/login') !== -1
}

function handleAuthExpired(config) {
    clearAuthToken()
    // 只有登录接口自身失败才清掉 code，允许重试用同一个 code；
    // 业务接口 401 时必须保留记录，否则 wxAuthLogin 会把 URL 里已消费的 code 再拿去换 token
    if (isLoginRequest(config)) {
        clearWxLoginCode()
        return
    }
    if (isRelogin) {
        return
    }
    isRelogin = true
    Toast.fail('登录已过期，正在重新登录')
    // 动态引入，避免与 wxLogin → api → request 循环依赖
    import('@/utils/wxLogin').then(({wxAuthLogin}) => {
        // 不传 location.pathname：它带部署 base，会被 router 再拼一次 base
        wxAuthLogin()
    }).finally(() => {
        setTimeout(() => {
            isRelogin = false
        }, 3000)
    })
}

// request 请求拦截器
requests.interceptors.request.use(config => {
    // 后端鉴权 JWT
    const authToken = getAuthToken()
    if (authToken) {
        config.headers['Authorization'] = 'Bearer ' + authToken
    }
    // 中联业务 token（与鉴权 JWT 分开）
    const zlToken = getToken()
    if (zlToken) {
        config.headers['token'] = zlToken
    }
    // 动态注入 USERID：公众号用 openid，国家医保用默认健康卡证件号
    const wxInfo = getWxInfo() || {}
    const defaultPatient = getDefaultPatientInfo() || {}
    if (getHealthCare() === '1') {
        if (defaultPatient.idNo) {
            config.headers['USERID'] = defaultPatient.idNo
        } else {
            delete config.headers['USERID']
        }
    } else if (wxInfo.openid) {
        config.headers['USERID'] = wxInfo.openid
    } else {
        delete config.headers['USERID']
    }
    // 渠道类型：1-国家医保，2-公众号
    config.headers['TYPE'] = getHealthCare() == '1' ? '1' : '2'
    return config
}, error => {
    Promise.reject(error)
})

// response 接收拦截器
requests.interceptors.response.use((response) => {
        const res = response.data
        if (res.code != 0 && res.code != 200 && res.code !== 1 && res.code != 201) {
            if (res.code === 401) {
                handleAuthExpired(response.config)
            } else {
                Toast.fail(res.message || res.msg);
            }
            return Promise.reject(res.msg)
        } else {
            return res
        }
    }, error => {
        let {message} = error;
        if (error.response && error.response.status === 401) {
            handleAuthExpired(error.config)
            return Promise.reject(error)
        }
        if (message === "Network Error") {
            Toast.fail('后端接口连接异常')
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        return Promise.reject(error)
    }
)


export default requests



// WEBPACK FOOTER //
// ./src/utils/request.js